import { useCreateEmptyFolder } from '@/hooks/useCreateEmptyFolder';
import { useTeamId } from '@/hooks/useWorkspace';
import cuid from 'cuid';
import { Info, Lock, Plus, Users } from 'lucide-react';
import { Button } from '../Button/Button';
import { useUpgrade } from '../Modals/UpgradeModal';
import { useTourTarget } from '../tour/useTourTarget';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/DropdownMenu';
import { Icon } from '../ui/Icon';
import { ReusableTooltip } from '../ui/ReusableTooltip';
export const FolderSelector = () => {
  const { createEmptyFolder } = useCreateEmptyFolder();
  const teamId = useTeamId();
  const { onClick } = useTourTarget('create-button');
  const { showUpgrade } = useUpgrade();
  return (
    <DropdownMenu
      onOpenChange={(open) => {
        if (open) {
          onClick();
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" id="create-button">
          <Icon as={Plus} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-40">
        <DropdownMenuItem onClick={() => createEmptyFolder({ id: cuid() })}>
          <Icon size="sm" as={Lock} />
          Private folder
          <ReusableTooltip
            triggerProps={{
              className: 'ml-auto',
            }}
            content="Visible to you"
            position="top"
          >
            <Icon
              size="sm"
              as={Info}
              className="text-muted-foreground hover:text-foreground"
            />
          </ReusableTooltip>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            if (!teamId) {
              showUpgrade('teamsFeature');
              return;
            }
            createEmptyFolder({ id: cuid(), teamId });
          }}
        >
          <Icon size="sm" as={Users} />
          Team folder
          <ReusableTooltip
            triggerProps={{
              className: 'ml-auto',
            }}
            content="Visible to everyone in your team"
            position="top"
          >
            <Icon
              size="sm"
              className="text-muted-foreground hover:text-foreground"
              as={Info}
            />
          </ReusableTooltip>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
